import React, { ReactNode } from 'react';
import { Separator } from '../SideBar/pages/Layers/styles';

interface IAnalytesModal {
  analytes: unknown;
}

const ANALYTE_LABELS: Record<string, string> = {
  valor: 'Valor',
  unidade: 'Unidade',
  valor_norm: 'Valor Normalizado',
  qualificador: 'Qualificador',
  quantidade: 'Quantidade',
};

function isValidURL(value: string): boolean {
  return /^(http:\/\/|https:\/\/|www\.)/.test(value);
}

function getAnalyteLabel(value: string): string {
  return ANALYTE_LABELS[value.toLocaleLowerCase('pt-BR')]
    ?? value.charAt(0).toLocaleUpperCase('pt-BR') + value.slice(1);
}

function renderPrimitive(value: unknown): ReactNode {
  if (value === null || value === undefined || String(value).trim() === '') {
    return null;
  }

  if (typeof value === 'number') return value.toLocaleString('pt-BR');
  if (typeof value === 'boolean') return value ? 'Sim' : 'Não';

  const textValue = String(value);
  if (isValidURL(textValue)) {
    return (
      <a href={textValue} target="blank">
        Mais info
      </a>
    );
  }

  return textValue;
}

function renderJsonValue(value: unknown, keyPrefix: string): ReactNode {
  if (value && typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>)
      .filter(([attributeName]) => attributeName.toLocaleLowerCase() !== 'amostra');
    if (entries.length === 0) return <p>{renderPrimitive(null)}</p>;

    return entries.map(([attributeName, attributeValue], index) => {
      const entryKey = `${keyPrefix}_${attributeName}_${index}`;
      const label = getAnalyteLabel(attributeName);

      if (attributeValue && typeof attributeValue === 'object') {
        const analyte = attributeValue as Record<string, unknown>;

        const value = analyte.valor ?? analyte.quantidade ?? 0;
        const unit = analyte.unidade ?? '';

        const sectionTitle =
          analyte.qualificador === 'N'
            ? `${label}: ${value} ${unit}`.trim()
            : `${label} ${analyte.qualificador ?? '='} ${value} ${unit}`.trim();

        return (
          <React.Fragment key={entryKey}>
            <div>
              <h4>
                <strong>{sectionTitle}</strong>
              </h4>
              {renderJsonValue(attributeValue, entryKey)}
            </div>
            <Separator />
          </React.Fragment>
        );
      }

      if (attributeValue === null || attributeValue === undefined || String(attributeValue).trim() === '') {
        return null;
      }

      return (
        <p key={entryKey}>
          <strong>{label}: </strong>
          <span>{renderPrimitive(attributeValue)}</span>
        </p>
      );
    });
  }

  return (
    <p>
      <strong>Valor: </strong>
      <span>{renderPrimitive(value)}</span>
    </p>
  );
}

export function AnalytesModal({ analytes }: IAnalytesModal) {

  return (
    <div className="content">
      <div className="information">
        {renderJsonValue(analytes, 'analitos')}
      </div>
    </div>
  );
}
